import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import VideoCard from "../components/VideoCard";

export default function GenreDetail() {
  const { slug } = useParams();
  const [videos, setVideos] = useState([]);
  const [genre, setGenre] = useState(null);

  useEffect(() => {
    api.get("/genres").then((r) => setGenre(r.data.find((g) => g.slug === slug)));
    api.get(`/videos?genre=${slug}&limit=100`).then((r) => setVideos(r.data));
  }, [slug]);

  return (
    <div>
      <div className="mb-8 rounded-3xl overflow-hidden relative h-48 border border-white/10">
        {genre && <img src={genre.image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-50" />}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0E] via-transparent to-[#0A0A0E]/60" />
        <div className="relative h-full flex items-end p-6 sm:p-10">
          <h1 className="font-display text-4xl sm:text-6xl font-extrabold">{genre?.name || slug}</h1>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {videos.map((v) => <VideoCard key={v.id} video={v} size="sm" queue={videos} />)}
      </div>
    </div>
  );
}
